import Modal from 'react-bootstrap/Modal';
import PrimaryButton from '../../components/button';


type Props = {
  show: boolean,
  hide: () => void,
  details: any,
  handleDetails: () => void,
}


function AvailableUserModal({ show, hide, details, handleDetails }: Props) {

  const membershipData = details?.memberShipPlans?.map((member: any) => ({
    membershipPlan: member?.memberShipPlan?.name,
    amount: member.amount,
    status: 'Active'
  }))


  return (
    <Modal show={show} onHide={hide} size="xl" centered>
      <Modal.Body>
        <div className='item-details-row-container'>
          <div className='row-container'>
            <div className='column-item'>
              <span className='key'>First Name</span>
              <span className='value'>{details?.firstName}</span>
            </div>
            <div className='column-item'>
              <span className='key'>Last Name</span>
              <span className='value'>{details?.lastName}</span>
            </div>
            <div className='column-item'>
              <span className='key'>Email</span>
              <span className='value'>{details?.email}</span>
            </div>
          </div>
          <div className='column-item'>
            {membershipData?.[0] && <div className="membership-badge-wrapper">
              <div className={`membership-circle ${membershipData?.[0]?.membershipPlan?.toLowerCase()}`}>
                <span className="circle-text">
                  {membershipData?.[0]?.membershipPlan?.charAt(0).toUpperCase() + membershipData?.[0]?.membershipPlan?.slice(1)}
                </span>
              </div>
            </div>}
          </div>
        </div>
        <div className='w-full ml-auto mt-5'>
          <PrimaryButton
            fullWidth
            label="View Details"
            onClick={() => {
              handleDetails();
              hide();
            }}
          />
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default AvailableUserModal;